import { render, staticRenderFns } from "./SpiderTable.vue?vue&type=template&id=d8f4ae42"
import script from "./SpiderTable.vue?vue&type=script&lang=js"
export * from "./SpiderTable.vue?vue&type=script&lang=js"
import style0 from "./SpiderTable.vue?vue&type=style&index=0&id=d8f4ae42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports